(function () {
    'use strict';
    /**
     * @memberof appback
     *@ngdoc service
     *@name WorkflowEjecucionesService
     *@description
     *Ejecuciones de workflow del usuario, con el estado de cada paso
     *(backend\controllers\WorkflowEjecucionesController)
     */

    angular
        .module('appback')
        .factory('WorkflowEjecucionesService', WorkflowEjecucionesService);

    WorkflowEjecucionesService.$inject = ["$http", "$q"];

    function WorkflowEjecucionesService($http, $q) {

        var service = {
            Listado: Listado,
        };

        /**
         * @param {Object} params Cuántas ejecuciones traer de cada columna: {en_curso: 20, completada: 20, ...}.
         * @param {boolean} silencioso true para el refresco automático: sin barra de carga.
         */
        function Listado(params, silencioso) {
            return $http.get('/backend/workflow-ejecuciones/listado', {
                params: params,
                ignoreLoadingBar: !!silencioso
            }).then(function (response) {
                if (!response.data || !response.data.success) {
                    return $q.reject(response.data);
                }

                return response.data.data;
            });
        }

        return service;
    }
})();
